export default "__VITE_ASSET__87f5ade0__"